import {
  combineReducers
} from 'redux';
import * as actionTypes from '../redux/actions/actionTypes';
import SearchIdReducer from './reducers/searchId';
import GenerateIdReducer from './reducers/generateId';
import AuthReducer from './reducers/auth';
import AdminComponentReducer from './reducers/adminPortal';
import UserReducer from './reducers/user';

const appReducer = combineReducers({
  search: SearchIdReducer,
  generateId: GenerateIdReducer,
  admin: AdminComponentReducer,
  auth: AuthReducer,
  user: UserReducer
});


export default (state, action) => {
  if (action.type === actionTypes.AUTH_LOGOUT) {
    state = undefined;
  }

  return appReducer(state, action);
};